// composables/useAuthState.js
export const useAuthState = () => {
  // 🔥 httpOnly: false로 클라이언트/서버 모두 접근 가능
  const authCookie = useCookie('auth', { 
    maxAge: 60 * 60 * 24,
    sameSite: 'lax',
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    // httpOnly: false는 기본값이므로 명시 안 해도 됨
  })
  
  const authData = computed(() => {
    if (!authCookie.value) return null
    try {
      return typeof authCookie.value === 'string' 
        ? JSON.parse(authCookie.value) 
        : authCookie.value
    } catch {
      return null
    }
  })
  
  const token = computed(() => authData.value?.token || null)
  const user = computed(() => authData.value?.user || null)
  const loginType = computed(() => authData.value?.loginType || null) 
  const isAuthenticated = computed(() => !!token.value)
  
  const setAuth = (newToken, newUser = {}, loginType = null) => {
    authCookie.value = JSON.stringify({
      token: newToken,
      user: newUser,
      loginType: loginType
    })        

    // 로그인 성공 시 내 찜 목록 로드
    if (import.meta.client) {
      const { fetchMyLikes } = useMyLikes();
      fetchMyLikes(true); // force=true로 재조회 강제
    }
  }
  
  const clearAuth = () => {
    authCookie.value = null    

    // 로그아웃 시 사용자별 캐시 정리
    if (import.meta.client) {
      const { reset: resetMyLikes } = useMyLikes();
      resetMyLikes();
    }
  }
  
  return { 
    token,
    user,
    loginType,
    isAuthenticated,
    setAuth,
    clearAuth
  }
}